<div class="card mt-5" *transloco="let t; prefix: 'userProfile.newsletter'">
  <div class="flex items-center gap-4">
    <div class="flex flex-col gap-2">
      <div class="font-semibold text-xl">{{ t('header') }}</div>
      <div>{{ t('description') }}</div>
    </div>
    <div class="flex items-center gap-2 ml-auto">
      <label for="newsletterSubscribed">{{ t('toggleLabel') }}</label>
      <p-toggleswitch
        inputId="newsletterSubscribed"
        data-testid="newsletter-toggle"
        [ngModel]="subscribed()"
        (ngModelChange)="onSubscribedChange($event)"
        [disabled]="loading() || saving()"
      />
    </div>
  </div>
  @if (pending()) {
    <div class="mt-4">
      <p-message severity="info" data-testid="newsletter-pending">{{ t('pending') }}</p-message>
    </div>
  }
  @if (bounced()) {
    <div class="mt-4">
      <p-message severity="warn" data-testid="newsletter-bounced">{{ t('bounced') }}</p-message>
    </div>
  }
</div>
